module.exports = __webpack_public_path__ + "img/keyboard_6.28faee19.png";